// A minimal external store for the two pieces of app state that must be set from OUTSIDE the
// React tree (TanStack Query's global QueryCache/MutationCache onError is a plain callback, not
// a hook) and read reactively INSIDE it (useSyncExternalStore). Not a state library — just
// enough to bridge the one imperative failure handler into UI: the archived full-stop flag and
// the palette's inline failure message. Two call sites; a hand-rolled ~15 lines beats a
// dependency (.claude/rules/core.md, design.md).

export interface ExternalStore<T> {
  get: () => T;
  set: (value: T) => void;
  subscribe: (listener: () => void) => () => void;
}

export function createExternalStore<T>(initial: T): ExternalStore<T> {
  let value = initial;
  const listeners = new Set<() => void>();
  return {
    get: () => value,
    set(next) {
      if (Object.is(value, next)) {
        return;
      }
      value = next;
      for (const listener of listeners) {
        listener();
      }
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}
